
import WasteTypeCreate from '../components/views/wasteType/wasteTypeCreate.vue'
import WasteType from '../components/views/wasteType/wasteType.vue'

const routes = [
    {
        path: 'wasteType',
        component: WasteType,
        name: 'wasteType',
        meta: {
            description: 'List of Waste Types',
            title: 'Waste Types',
            requiresAuth: true
        }
    },
    {
        path: 'wasteType/wasteTypeCreate',
        component: WasteTypeCreate,
        name: 'wasteTypeCreate',
        meta: {
            title: 'Add / Update Waste Type ',
            requiresAuth: true
        }
    },
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/wastetype.route.js